import { createAction, props } from '@ngrx/store';
import { AppSettingsState } from './app-settings.models';

export const initAppSettings = createAction('[AppSettings Page] Init');

export const loadAppSettingsSuccess = createAction(
  '[AppSettings/API] Load AppSettings Success',
  props<{ appSettings: AppSettingsState }>()
);

export const loadAppSettingsFailure = createAction(
  '[AppSettings/API] Load AppSettings Failure',
  props<{ error: unknown }>()
);

export const updateHeaderText = createAction(
  '[AppSettings/UI] Update Header Text',
  props<{ headerText: string }>()
);

export const updatecurrentUrl = createAction(
  '[AppSettings/UI] Update Current Page',
  props<{ currentUrl: string }>()
);
